import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import FormValidation from "../../components/FormValidation";
import {
  pushEvent,
  hotelCartItems,
  hotelCartValue,
  restaurantItemsFromState,
} from "../../utils/datalayer";

function PersonalInfo() {
  const bookingParam = useSelector((s) => s.bookingParam);
  const restaurant = useSelector((s) => s.restaurant);
  const restaurantHotel = useSelector((s) => s.restaurantHotel);
  const hotelSettings = useSelector((s) => s.settings.hotelSettings);
  const location = useLocation();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;

    const isRestaurantOnly =
      typeof location.pathname === "string" &&
      /\/restaurant\/personal-information/.test(location.pathname);

    const deposit = Number(
      (hotelSettings && hotelSettings.secure_restaurant_amount) || 0,
    );

    let items = [];
    let value = Number((bookingParam && bookingParam.totalPrice) || 0);

    if (isRestaurantOnly) {
      items = restaurantItemsFromState(restaurant, deposit);
      if (!value) value = Number(bookingParam.totalAmountToBlock) || 0;
    } else {
      const nights = (bookingParam && bookingParam.totalNights) || 1;
      const rooms = (bookingParam && bookingParam.rooms) || [];
      items = hotelCartItems(rooms, nights);
      const restItems = restaurantItemsFromState(restaurantHotel, deposit);
      if (restItems.length) items = items.concat(restItems);
      if (!value) value = hotelCartValue(rooms, nights);
    }

    if (!items.length) return;
    pushEvent("begin_checkout", items, value);
    fired.current = true;
  }, [bookingParam, restaurant, restaurantHotel, hotelSettings, location.pathname]);

  return (
    <div className="flex flex-col gap-5 bg-slate-50 col-span-2">
      <FormValidation />
    </div>
  );
}

export default PersonalInfo;
